import { render } from "./GoalsStatusCard.vue?vue&type=template&id=48e40876"
import script from "./GoalsStatusCard.vue?vue&type=script&lang=js"
export * from "./GoalsStatusCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__